import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Preloader } from 'react-materialize';

class Loading extends PureComponent {
  shouldComponentUpdate(nextProps) {
    const { loading } = this.props;
    return loading !== nextProps.loading;
  }

  render() {
    return (
      <div className="row center-align">
        <Preloader flashing size="small" />
      </div>
    );
  }
}

function mapStateToProps({ loading }) {
  return { loading };
}

export default connect(mapStateToProps)(Loading);



// WEBPACK FOOTER //
// ./src/components/Global/Loading.js